/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgToolbarUndo: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                d="M5.146 5.069c.115.038.217.024.317.024 2.036 0 4.073-.003 6.11.002a5.58 5.58 0 013.448 1.168c1.366 1.042 2.168 2.429 2.409 4.129.23 1.629-.104 3.143-1.035 4.5-1.043 1.518-2.492 2.388-4.33 2.592-.093.01-.187.012-.28.012-.904.002-1.807 0-2.71.004-.215 0-.406-.052-.564-.198a.748.748 0 01.267-1.264c.123-.043.25-.046.378-.046.75 0 1.5-.016 2.25.003 2.124.053 3.851-1.395 4.385-3.326.441-1.592.183-3.086-.85-4.395-.857-1.084-1.997-1.66-3.389-1.67-2.053-.013-4.107-.003-6.161-.002-.074 0-.152-.019-.226.024-.014.084.057.118.1.162.342.346.686.688 1.03 1.032.072.073.144.145.196.235a.746.746 0 01-.133.935.715.715 0 01-.916.078 1.76 1.76 0 01-.273-.23 1282.49 1282.49 0 01-2.332-2.333 1.676 1.676 0 01-.184-.211.728.728 0 01-.008-.882c.053-.077.117-.147.183-.213.782-.785 1.565-1.569 2.35-2.351.078-.078.162-.153.253-.214a.728.728 0 01.973.118c.239.26.254.675.033.966-.046.061-.101.115-.156.17-.318.32-.639.638-.957.959-.059.06-.13.11-.178.222"
            />
            <path d="M0 0h20v20H0z" />
        </g>
    </svg>
);
